import { gql } from "@apollo/client";

// eslint-disable-next-line import/prefer-default-export
export const SIGNED_FILE_URL_QUERY = gql`
  query SIGNED_FILE_URL_QUERY($input: SignedFileUrlInput!) {
    signedFileUrl(input: $input)
  }
`;
